import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  showHeader: boolean = true;
  constructor(
    private _router: Router,
    private _auth: AuthServiceLocal,
  ) {

    this._router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        console.log("val", val);
        this.showHeader = !!(String(val).match('orders'));
      }
    })

  }


  userLogout() {
    this._auth.userLogout();
  }
}
